import type { ReactNode } from "react";
import { cx } from "class-variance-authority";

import { Typography } from "../Typography/Typography";
import * as styles from "./FormControl.module.scss";

type FormControlProps = {
  title?: string;
  description?: string | ReactNode;
  children: ReactNode;
  shouldCollapse?: boolean;
  noSpacing?: boolean;
};

const FormControl = ({
  title,
  description,
  children,
  shouldCollapse = true,
  noSpacing,
}: FormControlProps) => {
  return (
    <div
      className={cx(styles.container, {
        [styles.shouldNotCollapse]: !shouldCollapse,
        [styles.noSpacing]: noSpacing,
      })}
      data-testid="form-control-container"
    >
      <div className={styles.titleAndDescription}>
        {title && (
          <Typography variant="h4" noSpacing>
            {title}
          </Typography>
        )}
        {description && (
          <Typography variant="body" className={styles.description} noSpacing>
            {description}
          </Typography>
        )}
      </div>
      <div className={styles.input}>{children}</div>
    </div>
  );
};

export { FormControl };
